export enum TypingTestState {
    NotStarted = 'Not Started',
    InProgress = 'In Progress',
    Completed = 'Completed'
}

export interface IDisplayScrollManager {
    scrollToCurrentWord(currentWordIndex: number): void;
    getDebugInfo(): string;
    reset(): void;
}